import { Card } from "design-system/molecules/Card"
import {
  ComparisonActivityChart,
  ComparisonChartConfig,
} from "design-system/organisms/insights/ComparisonActivityChart"
import { useTranslation } from "react-i18next"
import { GetDeflectionActivityResponseDataSchema } from "schema"
import { z } from "zod"

type Props = {
  data: z.infer<typeof GetDeflectionActivityResponseDataSchema> | undefined
  isPending: boolean
}

export function BackofficeSupportDeflectionActivity({ data, isPending }: Props) {
  const { t } = useTranslation()
  const chartConfig = {
    inbound: {
      label: t("dashboard.activity.inbound"),
      color: "var(--chart-secondary)",
      type: "bar",
    },
    deflected: {
      label: t("dashboard.activity.deflected"),
      color: "var(--chart-primary)",
      type: "bar",
    },
    containmentRate: {
      label: t("dashboard.metrics.containmentRate.title"),
      color: "var(--success)",
      type: "line",
    },
  } satisfies ComparisonChartConfig
  const chartData = data?.dailyCount.every(({ baseValue }) => baseValue === 0)
    ? []
    : data?.dailyCount.map((day) => ({
        date: day.date,
        inbound: day.baseValue,
        deflected: day.topValue,
        containmentRate: day.rate !== undefined ? Math.round(day.rate * 100) : undefined,
      }))

  return (
    <Card className="p-4">
      <ComparisonActivityChart
        data={chartData}
        chartConfig={chartConfig}
        chartClassName="h-[140px]"
        isPending={isPending}
        noDataT={{
          title: t("dashboard.activity.noData.title"),
          description: t("dashboard.activity.noData.description"),
        }}
        legendTooltipByKey={{
          containmentRate: t("dashboard.tooltip.activity.containmentRateLegendTooltip"),
        }}
      />
    </Card>
  )
}
